import React, { useState, useEffect, useContext } from 'react'
import {
  Alert,
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Spinner,
} from 'react-bootstrap'
import postalCodes from '../data/postalCodes.json'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { Formik } from 'formik'
import * as yup from 'yup'
import { Helmet } from 'react-helmet'
import { AuthContext } from './AuthContext'

const Register = () => {
  const { baseUrl, sendDiscordNotification } = useContext(AuthContext)
  const registerUrl = '/api/crm/clinic/register'
  const [errShow, setErrShow] = useState({ show: false, msg: '' })
  const [success, setSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [selectedCity, setSelectedCity] = useState('')
  const [codes, setCodes] = useState([
    '松山區',
    '信義區',
    '大安區',
    '中山區',
    '中正區',
    '大同區',
    '萬華區',
    '文山區',
    '南港區',
    '內湖區',
    '士林區',
    '北投區',
  ])
  const [selectedcode, setSelectedCode] = useState('')
  // const [registrationInfo, setRegistrationInfo] = useState({
  //   inc_id: '',
  //   hosp_id: '',
  //   password: '',
  //   institutionName: '',
  //   contactPhone: '',
  //   email: '',
  // })
  const navigate = useNavigate()

  useEffect(() => {
    const newObj = postalCodes.filter((v) => v.city.includes(selectedCity))
    setCodes(newObj[0].codes)
    setSelectedCode(newObj[0].codes[0])
  }, [selectedCity])

  const handleSubmit = (values) => {
    // e.preventDefault()
    setIsLoading(true)

    const requestBody = {
      inc_id: values.inc_id,
      hosp_id: values.hosp_id,
      name: values.institutionName,
      password: values.password,
      tel: values.contactPhone,
      email: values.email,
      city: values.city,
      dist: values.dist,
    }

    // console.log('register requestBody', requestBody)
    axios
      .post(baseUrl + registerUrl, requestBody, {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          Accept: '*/*',
        },
      })
      .then((res) => {
        // TODO: 成功才跳轉
        // console.log('res', res)

        if (res.data.error?.code === '10001') {
          // 參數不足
        } else if (res.data.error?.code === '10030') {
          // 指定機構不存在

          setErrShow({
            show: true,
            msg: res.data.error.message,
          })
          setTimeout(() => {
            setErrShow({ show: false, msg: '' })
          }, 5000)
        } else if (res.data.error?.code === '10023') {
          // 機構院所已存在
          setErrShow({
            show: true,
            msg: res.data.error.message,
          })
          setTimeout(() => {
            setErrShow({ show: false, msg: '' })
          }, 5000)
        } else if (res.data.message === '註冊成功') {
          setSuccess(true)
          // console.log('success', res)
          setTimeout(() => {
            navigate('/')
          }, 3000)
          sendDiscordNotification(
            `有人註冊ㄌ   \n RequestBody: ${JSON.stringify(requestBody.name)}`
          )
        }
      })
      .catch((e) => {
        console.log('e', e)
        setErrShow({
          show: true,
          msg: '伺服器忙碌中，請稍後再試',
        })
        setTimeout(() => {
          setErrShow({ show: false, msg: '' })
        }, 5000)

        sendDiscordNotification(
          `註冊失敗 \n Error: ${e}  \n RequestBody: ${JSON.stringify(
            requestBody.inc_id
          )}`
        )
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const vaildSchema = yup.object().shape({
    inc_id: yup
      .number()
      .typeError('統一編號必須是數字')
      .min(8, '*統一編號長度至少為 8 個字元'),
    hosp_id: yup
      .number()
      .typeError('醫事機構代碼必須是數字')
      .required('*醫事機構代碼不得空白'),
    password: yup
      .string()
      .min(8, '*密碼設定長度至少為 8 個字元')
      .required('*密碼不得空白'),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref('password')], '*輸入密碼不一致，請再試一次')
      .required('*確認密碼不得空白'),
    institutionName: yup.string().required('*機構名稱不得空白'),
    contactPhone: yup.string().required('*連絡電話不得空白'),
    email: yup.string().email('*電子郵件格式有誤').required('*Email 不得空白'),
    city: yup
      .string()
      .required('*請選擇所在縣市')
      .oneOf(
        postalCodes.map((v) => v.city),
        '*請選擇所在縣市'
      ),
    dist: yup
      .string()
      .required('*請選擇所在鄉鎮(市)區')
      .oneOf(
        codes.map((v) => v),
        '*請選擇所在鄉鎮(市)區'
      ),
  })

  return (
    <>
      <Helmet>
        <title>註冊帳號 | HA! CRM</title>
      </Helmet>
      <Container className="settings">
        <Row
          className="justify-content-md-center align-items-center "
          style={{ height: '100vh' }}
        >
          <Col sm={8}>
            <Card>
              <Card.Header>註冊新帳號</Card.Header>
              <Card.Body>
                <Formik
                  validationSchema={vaildSchema}
                  onSubmit={(values, { setSubmitting, resetForm }) => {
                    // When button submits form and form is in the process of submitting, submit button is disabled
                    // console.log('onSubmit', values)
                    setSubmitting(true)
                    handleSubmit(values)
                    // Resets form after submission is complete
                    setTimeout(() => {
                      resetForm()
                      setSubmitting(false)
                    }, 5000)

                    // Sets setSubmitting to false after form is reset
                  }}
                  initialValues={{
                    inc_id: '',
                    hosp_id: '',
                    password: '',
                    confirmPassword: '',
                    institutionName: '',
                    contactPhone: '',
                    email: '',
                    city: '',
                    dist: '',
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                  }) => {
                    const handleCityChange = (e) => {
                      handleChange(e) // 调用Formik的handleChange
                      setSelectedCity(e.target.value) // 调用你自己的setSelectedCity函数
                    }
                    const handleDistChange = (e) => {
                      handleChange(e)
                      setSelectedCode(e.target.value)
                    }
                    return (
                      <Form onSubmit={handleSubmit}>
                        {/* {console.log(handleChange)} */}
                        <Row>
                          <Form.Group
                            as={Col}
                            className="mb-3"
                            controlId="hosp_id"
                          >
                            <Form.Label>
                              醫事機構代碼<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="hosp_id"
                              value={values.hosp_id}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              placeholder="0000111100"
                              className={
                                touched.hosp_id && errors.hosp_id
                                  ? 'border border-danger border-2'
                                  : null
                              }
                            />
                            {touched.hosp_id && errors.hosp_id ? (
                              <div className="text-danger">
                                {errors.hosp_id}
                              </div>
                            ) : null}
                          </Form.Group>

                          <Form.Group
                            as={Col}
                            className="mb-3"
                            controlId="inc_id"
                          >
                            <Form.Label>統一編號(非必填)</Form.Label>
                            <Form.Control
                              type="text"
                              name="inc_id"
                              value={values.inc_id}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              placeholder="12345678"
                              className={
                                touched.inc_id && errors.inc_id
                                  ? 'border border-danger border-2'
                                  : null
                              }
                            />
                            {touched.inc_id && errors.inc_id ? (
                              <div className="text-danger">{errors.inc_id}</div>
                            ) : null}
                          </Form.Group>
                        </Row>

                        <Row>
                          <Form.Group
                            as={Col}
                            className="mb-3"
                            controlId="password"
                          >
                            <Form.Label>
                              密碼<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="password"
                              name="password"
                              value={values.password}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              placeholder="密碼設定長度至少為 8 個字元"
                              className={
                                touched.password && errors.password
                                  ? 'border border-danger border-2'
                                  : null
                              }
                            />
                            {touched.password && errors.password ? (
                              <div className="text-danger">
                                {errors.password}
                              </div>
                            ) : null}
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            className="mb-3"
                            controlId="confirmPassword"
                          >
                            <Form.Label>
                              請再次輸入密碼
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="password"
                              name="confirmPassword"
                              value={values.confirmPassword}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              placeholder="請再次輸入密碼"
                              className={
                                touched.confirmPassword &&
                                errors.confirmPassword
                                  ? 'border border-danger border-2'
                                  : null
                              }
                            />
                            {touched.confirmPassword &&
                            errors.confirmPassword ? (
                              <div className="text-danger">
                                {errors.confirmPassword}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Row>

                        <Row>
                          <Form.Group
                            as={Col}
                            className="mb-3"
                            controlId="institutionName"
                          >
                            <Form.Label>
                              機構名稱 <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="institutionName"
                              value={values.institutionName}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              placeholder="HA 診所"
                              className={
                                touched.institutionName &&
                                errors.institutionName
                                  ? 'border border-danger border-2'
                                  : null
                              }
                            />
                            {touched.institutionName &&
                            errors.institutionName ? (
                              <div className="text-danger">
                                {errors.institutionName}
                              </div>
                            ) : null}
                          </Form.Group>

                          <Form.Group
                            as={Col}
                            className="mb-3"
                            controlId="contactPhone"
                          >
                            <Form.Label>
                              連絡電話<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="tel"
                              name="contactPhone"
                              value={values.contactPhone}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              placeholder="02-12345678 / 0912345678"
                              className={
                                touched.contactPhone && errors.contactPhone
                                  ? 'border border-danger border-2'
                                  : null
                              }
                            />
                            {touched.contactPhone && errors.contactPhone ? (
                              <div className="text-danger">
                                {errors.contactPhone}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Row>

                        <Form.Group className="mb-3" controlId="email">
                          <Form.Label>
                            Email<span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            value={values.email}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            placeholder="ha@example.com"
                            className={
                              touched.email && errors.email
                                ? 'border border-danger border-2'
                                : null
                            }
                          />
                          {touched.email && errors.email ? (
                            <div className="text-danger">{errors.email}</div>
                          ) : null}
                        </Form.Group>

                        <Row className="mb-3">
                          <Form.Group as={Col} controlId="city">
                            <Form.Label>
                              所在縣市<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Select
                              name="city"
                              value={values.city}
                              onBlur={handleBlur}
                              onChange={handleCityChange}
                              className={
                                touched.city && errors.city
                                  ? 'border border-danger border-2'
                                  : null
                              }
                            >
                              <option value="">請選擇縣市</option>
                              {postalCodes.map((v, i) => {
                                return (
                                  <option key={i} value={v.city}>
                                    {v.city}
                                  </option>
                                )
                              })}
                            </Form.Select>
                            {touched.city && errors.city ? (
                              <div className="text-danger">{errors.city}</div>
                            ) : null}
                          </Form.Group>
                          <Form.Group as={Col} controlId="postalCode">
                            <Form.Label>
                              鄉鎮(市)區<span className="text-danger">*</span>
                            </Form.Label>

                            <Form.Select
                              name="dist"
                              value={values.dist}
                              onBlur={handleBlur}
                              onChange={handleDistChange}
                              className={
                                touched.dist && errors.dist
                                  ? 'border border-danger border-2'
                                  : null
                              }
                            >
                              <option value="">請選擇鄉鎮(市)區</option>
                              {codes.map((v, i) => {
                                return (
                                  <option key={i} value={v}>
                                    {v}
                                  </option>
                                )
                              })}
                            </Form.Select>
                            {touched.dist && errors.dist ? (
                              <div className="text-danger">{errors.dist}</div>
                            ) : null}
                          </Form.Group>
                        </Row>
                        {errShow.show && (
                          <Alert
                            variant="danger"
                            onClose={() => setErrShow({ show: false, msg: '' })}
                            dismissible
                            className="fs-6"
                          >
                            <i className="fa-solid fa-triangle-exclamation"></i>{' '}
                            {errShow.msg}
                          </Alert>
                        )}
                        {success && (
                          <Alert
                            variant="success"
                            onClose={() => setSuccess(false)}
                            dismissible
                            className="fs-6"
                          >
                            <i className="fa-regular fa-face-smile"></i>
                            {'  '}
                            帳號註冊成功！ 3 秒後跳轉至首頁，請重新登入
                          </Alert>
                        )}

                        <div className="d-flex">
                          <Button
                            type="submit"
                            variant="primary"
                            className="ms-auto"
                            disabled={isSubmitting}
                            // onClick={handleSubmit}
                          >
                            建立新帳號{' '}
                            <Spinner
                              as="span"
                              animation={isLoading ? 'border' : ''}
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          </Button>
                        </div>
                      </Form>
                    )
                  }}
                </Formik>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Register
